/* eslint-disable max-statements */
import {FormEvent, useEffect, useState} from 'react';

import {
    sendDesktopAnalyticsEvent,
    sendDesktopAnalyticsPerSession,
} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {useInView} from 'react-intersection-observer';
import {useDispatch, useSelector} from 'react-redux';

import {CART_BUTTON} from 'constants/analytics/events/cart';
import {AppThunkDispatchType} from 'desktop/store';

import {addCoupon} from '../../store/reducers/coupons/coupons';
import {getCouponsStatus, getErrorCouponsMessage} from '../../store/selectors/coupons/coupons';

/**
 * Cart form logic hook
 */
export const useCouponForm = () => {
    const dispatch = useDispatch<AppThunkDispatchType>();
    const errors = useSelector(getErrorCouponsMessage);
    const status = useSelector(getCouponsStatus);

    const [value, setValue] = useState('');
    const [processedCoupon, setProcessedCoupon] = useState('');
    const {inView, ref} = useInView();
    const errorMessage = errors.join(`, `);

    useEffect(() => {
        if ((status === 'fulfilled' || status === 'rejected') && processedCoupon) {
            sendDesktopAnalyticsEvent(CART_BUTTON, {
                action: `Apply Coupon - ${status === 'rejected' ? 'Error' : 'Success'}`,
                label:
                    status === 'rejected'
                        ? `${processedCoupon} - ${errorMessage}`
                        : processedCoupon,
            });

            setProcessedCoupon('');
        }
    }, [errorMessage, processedCoupon, status]);

    useEffect(() => {
        if (inView) {
            sendDesktopAnalyticsPerSession({
                event: CART_BUTTON,
                label: {action: 'Right Section', label: 'Visible - Coupon Box'},
            });
        }
    }, [inView]);

    /**
     * Add coupon to cart handler
     * @param {FormEvent} event  window event
     */
    const onSubmit = async (event: FormEvent) => {
        event.preventDefault();

        if (value) {
            setProcessedCoupon(value);
            // for new version need to clear input value only when coupon applied successfully
            await dispatch(addCoupon(value));

            setValue('');
        }
    };

    return {
        errorMessage,
        onSubmit,
        ref,
        setValue,
        status,
        value,
    };
};
